import styled from 'styled-components';

const PartnersContainer = styled.div`
  flex: 1;
  width: 100%;
`;

export { PartnersContainer };
